import { OrderBy, TableParam } from '../classes/table-param';
import { MainConstants } from '../config/app.constant';
import { Params } from '@angular/router';

export function getDefaultTableParams(sortBy: string = 'name', orderBy?: OrderBy, scope?: string): TableParam {
  return {
    page: 1,
    pageSize: MainConstants.defaultPageSize,
    sortBy: sortBy,
    orderBy: orderBy || OrderBy.Asc,
    searchText: null,
    scope: scope || null,
    specialisationId: null,
    hideResolved: null,
  };
}

export function getParams(
  param: Params,
  sortBy: string = 'name',
  scope?: string,
  orderBy: OrderBy = OrderBy.Asc
): TableParam {
  return {
    page: +param['page'] || 1,
    pageSize: +param['pageSize'] || MainConstants.defaultPageSize,
    searchText: param['searchText'] || null,
    sortBy: param['sortBy'] || sortBy,
    orderBy: param['orderBy'] || orderBy,
    scope: param['scope'] || scope || null,
    specialisationId: param['specialisationId'] || null,
    hideResolved: param['hideResolved'] !== undefined ? param['hideResolved'] === 'true' : null,
  };
}

export function tableParamToQueryParam(tableParams: TableParam): Record<string, string> {
  const currentParams = tableParams;

  let queryParams = {};

  Object.keys(currentParams).forEach((_key) => {
    const key = _key as keyof TableParam;

    if (
      currentParams[key] !== null &&
      currentParams[key] !== undefined &&
      currentParams[key] !== 0 &&
      currentParams[key] !== ''
    ) {
      queryParams = { ...queryParams, [key]: currentParams[key].toString() };
    }
  });

  return queryParams;
}
